import { render } from "./componentRevenue.vue?vue&type=template&id=6d0544f7&ts=true"
import script from "./componentRevenue.vue?vue&type=script&lang=ts"
export * from "./componentRevenue.vue?vue&type=script&lang=ts"

import "./componentRevenue.vue?vue&type=style&index=0&id=6d0544f7&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__